import { useQuery } from '@apollo/client'
import { TEST_SESSION_DETAIL } from './operations'
import {
  TestSessionWithoutMembersWithResult,
  TestSessionWithoutMembersWithResultVariables,
} from '../../types'

interface UseSessionDetailProps {
  testSessionId: string
  userId?: string
  skipResult: boolean
  onCompleted?: (data: TestSessionWithoutMembersWithResult) => void
}

export const useTestSessionWithoutMembers = ({
  testSessionId,
  userId,
  skipResult,
  onCompleted,
}: UseSessionDetailProps) =>
  useQuery<TestSessionWithoutMembersWithResult, TestSessionWithoutMembersWithResultVariables>(
    TEST_SESSION_DETAIL,
    {
      variables: {
        id: testSessionId,
        skipResult: skipResult,
        groupsInputData: { ...(userId ? { memberUserIds: [userId] } : {}) },
        companyInputData: { ...(userId ? { memberUserIds: [userId] } : {}) },
      },
      onCompleted,
    }
  )
